var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{class:_vm.context.classes.label,attrs:{"id":((_vm.context.id) + "_label"),"for":_vm.context.id}},[_vm._v(" "+_vm._s(_vm.context.label)+" "),(_vm.required)?_c('span',{staticClass:"required"},[_vm._v("*")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }